import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../utils/Requests/axios";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";

function DeleteWebsiteSection({ termsData }) {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const handleDeleteWebsite = () => {
    const url = `/sellers/${userData?.uuid}/terms/${termsData?.terms?.uuid}`;
    axiosInstance
      .delete(url)
      .then(() => {
        navigate("/websites");
        toast.success(t("Website deleted successfully"));
      })
      .catch(() => {
        toast.error(t("There was an error deleting the Website"));
      });
  };

  return (
    <div id="deleteWebsiteSection" className="card card-setting">
      <div className="card-header">
        <h4 className="card-title">{t("Delete Website")}</h4>
      </div>

      <div className="card-body">
        <p className="card-text">
          {t(
            "When you delete your website, you lose access to it, and we permanently delete your personal data. You can cancel the deletion for 14 days."
          )}
        </p>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="deleteAccountCheckbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor="deleteAccountCheckbox">
            {t("Confirm that I want to delete my website.")}
          </label>
        </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end gap-3 card-body pt-3">
        {/* eslint-disable-next-line */}
        <a href="javascript:;" className="btn btn-outline-primary py-1">
          {t("Learn more")}
        </a>
        <button
          className="btn btn-danger py-1"
          onClick={handleDeleteWebsite}
          disabled={!isChecked}
        >
          {t("Delete")}
        </button>
      </div>
    </div>
  );
}

export default DeleteWebsiteSection;
